var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.978 7.31544L14.978 3.29403C13.252 1.90655 10.748 1.90655 9.022 3.29403L4.022 7.31544C2.896 8.22075 2.25 9.5682 2.25 11.0127V17.0068C2.25 19.6237 4.381 21.7534 7 21.7534H9.75V17.0068C9.75 15.7684 10.759 14.76 12 14.76C13.241 14.76 14.25 15.7684 14.25 17.0068V21.7534H17C19.619 21.7534 21.75 19.6247 21.75 17.0068V11.0127C21.75 9.5682 21.104 8.22075 19.978 7.31544ZM20.25 17.0068C20.25 18.7964 18.792 20.2529 17 20.2529H15.75V17.0068C15.75 14.9411 14.068 13.2594 12 13.2594C9.932 13.2594 8.25 14.9411 8.25 17.0068V20.2529H7C5.208 20.2529 3.75 18.7964 3.75 17.0068V11.0127C3.75 10.0254 4.191 9.10406 4.961 8.48485L9.961 4.46344C11.143 3.51411 12.857 3.51411 14.038 4.46344L19.038 8.48485C19.808 9.10406 20.249 10.0254 20.249 11.0127V17.0068H20.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0b16b1b2.svg";
export { ForwardRef as ReactComponent };